/**
 * Standalone enum for suggestion types.
 */

import { z } from "zod";

export const SuggestionTypeSchema = z.enum({
  PROFILE_BASED: "profile_based",
  TOPIC_BASED: "topic_based",
  EXPERTISE_BASED: "expertise_based",
  AI_CUSTOM: "ai_custom",
});

export type SuggestionTypeType = z.infer<typeof SuggestionTypeSchema>;

export const SuggestionType = SuggestionTypeSchema.enum;
